/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/focusableInput.form.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'focusableInput/form', exports: {} }; const exports = module.exports;

import $ from '@grins/fd-modules/jQuery';

import { focusableInput_error as focusableError } from '@grins/fd-modules/splits/onering-global';

import { focusableInput_passwordToggle as passwordToggle } from '@grins/fd-modules/splits/onering-global';

import { Fandango_clearableInput as clearableInput } from '@grins/fd-modules/splits/onering-global';

const Selectors = {
    INPUT: '.js-fcsbl-input',
    TOGGLE: '.js-fcsbl-pw-toggle',
}
function onValueChange() {
    const $input = $(this);
    focusableError.toggle($input, '', false);
}
function attach(form) {
    form.querySelectorAll(Selectors.INPUT)
        .forEach((field) => {
        const { id } = field;
        const isPassword = field.type === 'password' && document.querySelector(`${Selectors.TOGGLE}[data-for="${id}"]`);
        if (isPassword) {
            passwordToggle.attach(id);
        }
        field.addEventListener('input', onValueChange);
    });
    clearableInput.attach();
}
export default {
    attach,
    toggleErrors(fields, show) {
        focusableError.toggleErrors(fields, show);
    }
};